/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SnippetPreviewRequestBodyDoc } from './snippetPreviewRequestBodyDoc';

export interface SnippetPreviewRequest {
  body_doc: SnippetPreviewRequestBodyDoc;
  /**
     * @minLength 1
     * @maxLength 200
     */
  job_title: string;
  /**
     * @minimum 1
     * @maximum 10
     */
  limit?: number;
  candidate_ids?: string[] | null;
  rotate?: boolean;
  exclude_candidate_ids?: string[] | null;
}
